import InteractionEvent, {
  type InteractionTargetType
} from './InteractionEvent';

export type RelatedSearchPlacement = 'header';

export type RelatedSearchTargetProperties = {
  placement: RelatedSearchPlacement;
  position: number;
  search_term?: string;
  selected_search_term: string;
};

type EventData = {
  gesture?: string;
  guestId?: string;
  isBot: boolean;
  placement: RelatedSearchPlacement;
  position: number;
  searchTerm?: string;
  selectedSearchTerm: string;
};

class RelatedSearchInteractionEvent extends InteractionEvent<
  EventData,
  RelatedSearchTargetProperties
> {
  protected get targetType(): InteractionTargetType {
    return 'related_search';
  }

  protected getTargetProperties(): RelatedSearchTargetProperties {
    return {
      placement: this.data.placement,
      position: this.data.position,
      search_term: this.data.searchTerm,
      selected_search_term: this.data.selectedSearchTerm
    };
  }
}

export default RelatedSearchInteractionEvent;
